import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
var ɵ0 = (createTranslateLoader);
var SharedModule = (function () {
    function SharedModule(translate) {
        this.translate = translate;
        translate.addLangs(['en', 'zh-CN']);
        translate.setDefaultLang('zh-CN');
        // const browserLang = translate.getBrowserLang();
        // translate.use(browserLang.match(/en|zh-CN/) ? browserLang : 'en');
    }
    return SharedModule;
}());
export { SharedModule };
var LanguageModule = (function () {
    function LanguageModule() {
    }
    return LanguageModule;
}());
export { LanguageModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /home/tg/github/freeng/src/app/democase/common/language.ts.pre-build-optimizer.js